import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {RequestReason} from '@employee-pages/badge-request-page/employee-badge-requests';
import {BadgeReasonEnum} from '@employee-models/data.enums';

@Component({
    selector: 'employee-request-details-mobile',
    templateUrl: './employee-request-details-mobile.component.html',
    styleUrls: ['./employee-request-details-mobile.component.less']
})
export class EmployeeRequestDetailsMobileComponent {
    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() requestReasonPayload: EmployeeModels.CM.IBadgeRequestPayloadModel;
    @Input() tabs: Array<RequestReason>;

    @Output() onRequestReasonSelect = new EventEmitter<RequestReason>();
    @Output() onLocationSelect = new EventEmitter<number>();
    @Output() onPreferredFullNameSelected = new EventEmitter<boolean>();
    @Output() onBloodGroupSelected = new EventEmitter<string>();

    readonly badgeRequestTypeEnum = EmployeeModels.DE.BadgeRequestTypeEnum;
    readonly badgeChangeReasonsCategories = BadgeReasonEnum;

    private minQueryLength: number = 1;
    filterQuery = '';
    pipeFilterQuery = '';
    isLocationDropdownOpen = false;
    filterBy: Record<string, string> = null;

    get isResubmission(): boolean {
        return this.requestData.badgeRequestType === EmployeeModels.DE.BadgeRequestTypeEnum.Resubmission
            && this.requestData.lastBadgeRequestReason in EmployeeModels.DE.BadgeReasonEnum;
    }

    get isFullNameChecked(): boolean {
        if (this.requestReasonPayload.isNameChanges) {
            return !this.requestReasonPayload.isPreferredFullName;
        }

        return !this.requestData.isPreferredFullName || (this.requestData.isPreferredFullName && !this.isResubmission);
    }

    get selectedBloodType(): string {
        return this.requestData.bloodGroups
        .find(i => i.bloodGroupId === this.requestReasonPayload.bloodGroupId)?.bloodGroupName || '';
    }

    pickRequestReason(tab: RequestReason): void {
        this.onRequestReasonSelect.emit(tab);
    }

    locationChanged(site: EmployeeModels.DM.ISiteDto): void {
        this.onLocationSelect.emit(site.siteId);
    }

    setFilterQuery(query: string): void {
        const trimmedQuery: string = query.trim();
        if (!trimmedQuery.length) {
            this.filterQuery = '';
            this.pipeFilterQuery = '';
        }

        this.pipeFilterQuery = (trimmedQuery.length < this.minQueryLength) ? '' : trimmedQuery;
        this.filterBy = this.pipeFilterQuery.length ? { siteName: this.pipeFilterQuery } : null;
    }

    toggle(): void {
        this.isLocationDropdownOpen = !this.isLocationDropdownOpen;
    }

    get hasFilteredResults(): boolean {
        return (!this.pipeFilterQuery.length)
            ? true
            : this.requestData.sites.some(option => option.siteName.toLowerCase().includes(this.pipeFilterQuery.toLowerCase()));
    }

    get isNoteBlockShown(): boolean {
        return [
            this.badgeChangeReasonsCategories.BadgeLost,
            this.badgeChangeReasonsCategories.BadgeStolen,
            this.badgeChangeReasonsCategories.BadgeDamaged
        ].includes(this.requestReasonPayload.reason);
    }

    onChangeName(isPreferredFullName: boolean): void {
        this.onPreferredFullNameSelected.emit(isPreferredFullName);
    }
}
